import React from 'react';
import { Server } from 'lucide-react';
import './OhipTransactionsPage.css';

// Legacy ▸ Connectors — superadmin.
//
// The pre-hub connectors: one lambda per connector, deployed from a per-connector snapshot rather than
// from the repo, with credentials in `connectorsettings` on the legacy database (AES blobs read through
// GETCONNECTORSETTING) rather than in `entity_credentials`. They are maintained here only until they are
// migrated into the hub — which is why this is its own section and not a product under Products.
//
// Kept deliberately empty for now. What goes here is decided by what the maintenance actually needs,
// and the recurring work so far has been: find a connector, read its settings, see whether its deployed
// lambda supports what the settings say (the OCIM switch on connector 1919 failed precisely because the
// deployed code predated the AUTHMETHOD setting and never read it), and know which snapshot a connector
// was built from. A screen that guesses at that before the shape is known is a screen to rewrite.
function LegacyConnectorsPage() {
    return (
        <div className="otx-page">
            <div className="otx-header">
                <div>
                    <h1>Legacy Connectors</h1>
                    <p className="otx-subtitle">
                        Pre-hub connectors — one lambda per connector, settings on the legacy database.
                        Maintained until each is migrated into the hub.
                    </p>
                </div>
            </div>

            <div className="otx-table-wrap" style={{ padding: '3rem 2rem', textAlign: 'center' }}>
                <Server size={32} style={{ color: '#9ca3af', marginBottom: '0.75rem' }} />
                <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>
                    Nothing here yet.
                </p>
                <p style={{ margin: '0.5rem auto 0', color: '#9ca3af', fontSize: '0.825rem', maxWidth: '58ch' }}>
                    This section is for maintaining connectors that predate the hub: their settings, which
                    build each one was deployed from, and whether that build supports the settings it has
                    been given.
                </p>
            </div>
        </div>
    );
}

export default LegacyConnectorsPage;
